<template>
  <div class="loading">
    <p class="h4 label-loading">{{ $t(`loading.${loadingLabel}`) }}</p>
    <div>
      <i class="fa fa-refresh fa-spin loading-icon"></i>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["loadingLabel"]),
  },

  mounted() {
    this.$store.commit("toggleSelectActivableOrder", false);
  },
};
</script>

<style lang="scss" scoped>
.loading {
  padding: 0 0.5rem;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .label-loading {
    text-align: center;
    margin-bottom: 3rem;
    font-weight: 700;
  }

  .loading-icon {
    font-size: 5rem;
  }
}
</style>>
